import React, { useState } from "react";
import { Mail, MapPin, Phone } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/api/contact", form);
      toast.success("Thanks! We'll get back to you within 1–2 business days.");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Sorry, something went wrong. Please try again.");
    } finally { setBusy(false); }
  };
  return (
    <div className="max-w-5xl mx-auto px-6 py-16" data-testid="contact-page">
      <div className="grid md:grid-cols-2 gap-12">
        <div>
          <div className="label-eyebrow">Contact us</div>
          <h1 className="font-display font-black text-4xl md:text-5xl mt-2 tracking-tight">Let's talk.</h1>
          <p className="mt-4 text-[#4B5563]">Questions about a course, refund or bulk enrolment? Reach out.</p>
          <div className="mt-8 space-y-4 text-sm">
            <div className="flex items-start gap-3"><MapPin className="w-4 h-4 text-[#D92D20] mt-0.5 shrink-0" />
              <div>
                <div className="font-semibold">Office</div>
                <div className="text-[#4B5563]">1212 31 Ave NE, unit 200<br/>Calgary, AB T2E 7S8</div>
              </div>
            </div>
            <div className="flex items-start gap-3"><Mail className="w-4 h-4 text-[#D92D20] mt-0.5 shrink-0" />
              <div>
                <div className="font-semibold">Emails</div>
                <div className="text-[#4B5563]">
                  <a href="mailto:info@teachmeonline.ca" className="hover:text-[#D92D20]">info@teachmeonline.ca</a>
                  <br/>
                  <a href="mailto:teachmeonlineca@gmail.com" className="hover:text-[#D92D20]">teachmeonlineca@gmail.com</a>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-3"><Phone className="w-4 h-4 text-[#D92D20]" /> <span className="text-[#4B5563]">Support hours: Mon–Fri, 9–5 MT</span></div>
          </div>
        </div>

        <form onSubmit={submit} className="bg-white border border-[#E5E7EB] rounded-2xl p-6 md:p-8 space-y-4">
          <div>
            <label className="text-sm font-semibold">Name</label>
            <input data-testid="contact-name" required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})}
              className="w-full mt-1 border border-[#E5E7EB] rounded-md px-3 py-2 text-sm focus:outline-none focus:border-[#D92D20]" />
          </div>
          <div>
            <label className="text-sm font-semibold">Email</label>
            <input data-testid="contact-email" required type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})}
              className="w-full mt-1 border border-[#E5E7EB] rounded-md px-3 py-2 text-sm focus:outline-none focus:border-[#D92D20]" />
          </div>
          <div>
            <label className="text-sm font-semibold">Message</label>
            <textarea data-testid="contact-message" required rows={5} value={form.message} onChange={(e) => setForm({...form, message: e.target.value})}
              className="w-full mt-1 border border-[#E5E7EB] rounded-md px-3 py-2 text-sm focus:outline-none focus:border-[#D92D20]" />
          </div>
          <button data-testid="contact-send" type="submit" disabled={busy} className="btn-primary w-full">
            {busy ? "Sending..." : "Send message"}
          </button>
        </form>
      </div>
    </div>
  );
}
